import { Result, SlideComponentHkcsEnQ2 } from '@/types/slide';
import { Box, Skeleton } from '@mui/material';
import { ResultContentContainer } from './ResultContentContainer';

import { PhraseHighlight } from '@/components/displays/PhraseHighlight';
import { ResultDisplayEnWriting } from '@/components/results/ResultDisplayEnWriting';
import { useEffect, useState } from 'react';
import { ImageShowcase } from '../../ImageShowcase';
import { PropsWithOnLoad } from '../../type';

export const ResultContentHkcsEnQ2: React.FC<
    PropsWithOnLoad & {
        question: SlideComponentHkcsEnQ2 & { answers: Result[] };
        viewOnly: boolean;
    }
> = ({ question, viewOnly, onLoad }) => {
    const answer = question.answers[0];
    const [loading, setLoading] = useState<boolean | undefined>(answer?.fetchResultFiles ? true : false);
    const [drawing, setDrawing] = useState<string | undefined>(undefined);

    const [loadCount, setLoadCount] = useState<number>((answer?.fetchResultFiles ? 1 : 0) + (question.content.imageURL || question.content.image ? 1 : 0));

    const handleLoadImage = () => {
        setLoadCount((prev) => prev - 1);
    };

    useEffect(() => {
        if (loadCount <= 0) {
            onLoad?.();
        }
    }, [loadCount, onLoad]);

    useEffect(() => {
        if (answer?.fetchResultFiles) {
            setLoading(true);
            answer
                .fetchResultFiles()
                .then((files) => {
                    if (files && files.length > 0) {
                        setDrawing(files[0]?.url);
                    } else {
                        setDrawing(undefined);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setDrawing(undefined);
        }
    }, [answer]);

    return (
        <ResultContentContainer>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', width: 594, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                    <Box>
                        <Box
                            sx={{
                                display: 'flex',
                                width: 215,
                                height: 221.25,
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between',

                                backgroundColor: 'white',
                                borderRadius: '16px',
                                paddingTop: 2,
                            }}
                        >
                            <ImageShowcase
                                width={120}
                                src={
                                    question.content.imageURL && question.content.imageURL !== ''
                                        ? question.content.imageURL
                                        : `/asset/characters/${question.content.image ? question.content.image + '/image.png' : 'default.png'}`
                                }
                                onLoad={handleLoadImage}
                            />
                            <PhraseHighlight sx={{ color: '#555', my: 2 }} phrase={question.content.phrase} highlight={question.content.phrase} underline={false} />
                        </Box>
                    </Box>

                    <Box sx={{ width: 360, height: 221.25, display: 'flex', flexDirection: 'column' }}>
                        {drawing ? (
                            <Box
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    borderRadius: 2,
                                    borderColor: 'divider',
                                    borderWidth: 2,
                                    backgroundColor: 'white',
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Box
                                    component={'img'}
                                    src={drawing}
                                    sx={{
                                        height: '100%',
                                        width: '100%',
                                        aspectRatio: 1,
                                        border: 2,
                                        borderRadius: 2,
                                        borderColor: 'divider',
                                    }}
                                    onLoad={handleLoadImage}
                                />
                            </Box>
                        ) : loading ? (
                            <Skeleton variant='rounded' sx={{ height: '100%', width: '100%', borderRadius: 2 }} />
                        ) : (
                            <Box
                                sx={{
                                    height: '100%',
                                    width: '100%',
                                    backgroundColor: 'white',
                                    borderRadius: 2,
                                    borderColor: 'divider',
                                    borderWidth: 2,
                                }}
                            />
                        )}
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: 594,
                        height: 68,

                        backgroundColor: 'white',
                        borderRadius: 1,
                        border: 2,
                        borderColor: 'divider',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <ResultDisplayEnWriting question={question} showReference={true} type={'sampleSentenceAnswer'} viewOnly={viewOnly} />
                </Box>

                <Box
                    sx={{
                        width: 594,
                        height: 110,
                        backgroundColor: 'white',
                        borderRadius: 1,
                        border: 2,
                        borderColor: 'divider',
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <ResultDisplayEnWriting question={question} showReference={true} type={'answer'} viewOnly={viewOnly} />
                </Box>
            </Box>
        </ResultContentContainer>
    );
};
